// extracted by mini-css-extract-plugin
var _1 = "bOseQmq7krUivibX7ThC";
var _2 = "LupO0eyKriegiGJ7VNfg";
var _3 = "KtgtvZLywhzUtA9uTzmP";
var _4 = "PHwWeLXMKUfXcg2323EN";
var _5 = "I1VapxHaxGP3sG4LPHjm";
var _6 = "FVGnl7fu0P3FU8OKm5oH";
export { _1 as "border", _2 as "icon", _3 as "iconHolder", _4 as "mainTitle", _5 as "page", _6 as "title" }
